import { Component, Input } from '@angular/core';
import { InfoField, InfoFieldItem } from '../../../../../components/shared/info-field/info-field';
import { FormatterHelperService } from '../../../../../services/helpers/formatter-helper.service';

@Component({
  selector: 'app-lead-details-sp',
  standalone: true,
  imports: [InfoField],
  templateUrl: './leads-details-sp.html',
  styleUrls: ['../shared/lead-detail-shared.scss'],
})
export class LeadsDetailsSp {
  leadInfo: InfoFieldItem[] = [];
  simulationInfo1: InfoFieldItem[] = [];
  simulationInfo2: InfoFieldItem[] = [];
  simulationInfo3: InfoFieldItem[] = [];

  @Input() set details(value: any) {
    if (value) {
      this.mapDetails(value);
    }
  }

  constructor(private readonly formatter: FormatterHelperService) {}

  private mapDetails(details: any): void {
    this.leadInfo = [
      { type: 'text', title: 'Nome', info: details.nome || '-' },
      { type: 'text', title: 'CPF', info: this.formatter.CPF(details.cpf) },
      { type: 'text', title: 'Data de Nascimento', info: this.formatter.data(details.dataNascimento) },
      { type: 'text', title: 'Tipo de pessoa', info: details.tipoPessoa || '-' },
      { type: 'text', title: 'Data de criação', info: this.formatter.data(details.dataCriacao) },
      { type: 'text', title: 'Preferência de contato', info: details.preferenciaContato || '-' },
      { type: 'text', title: 'DN atual', info: details.dn?.toString() || '-' },
      { type: 'text', title: 'Celular', info: this.formatter.celular(details.celular) },
      { type: 'text', title: 'Telefone residencial', info: this.formatter.telefone(details.telefoneResidencial) },
      { type: 'text', title: 'Telefone comercial', info: this.formatter.telefone(details.telefoneComercial) },
      { type: 'text', title: 'Telefone adicional', info: this.formatter.telefone(details.telefoneAdicional) },
      { type: 'text', title: 'E-mail', info: details.email || '-' },
      {
        type: 'status',
        title: 'Status',
        info: details.statusDoLead || '-',
        leadId: details.idLead,
        cdSiglaTipo: details.cdSiglaTipo,
      },
      { type: 'text', title: 'CEP', info: this.formatter.CEP(details.cep) },
      { type: 'text', title: 'Estado', info: details.estado || '-' },
      { type: 'text', title: 'Cidade', info: details.cidade || '-' },
    ];
    this.simulationInfo1 = [
      { type: 'text', title: 'Número do contrato', info: details.codigoContrato || '-' },
      { type: 'text', title: 'Término do contrato', info: this.formatter.data(details.dataFimContrato) },
      { type: 'text', title: 'Disponível desde', info: this.formatter.data(details.disponivelDesde) },
      { type: 'text', title: 'Valor da mensalidade', info: this.formatter.moeda(details.valorMensalidadeAssinatura) },
      { type: 'text', title: 'Prazo', info: details.quantidadeParcelas?.toString() || '-' },
    ];
    this.simulationInfo2 = [
      { type: 'text', title: 'Marca', info: details.marca || '-' },
      { type: 'text', title: 'Modelo', info: details.modeloGrupo || '-' },
      { type: 'text', title: 'Modelo Completo', info: details.modeloCompleto || '-' },
      { type: 'text', title: 'Versão', info: details.versao || '-' },
      { type: 'text', title: 'Chassi', info: details.chassi || '-' },
    ];
    this.simulationInfo3 = [{ type: 'text', title: 'Observações', info: details.observacoes || '-' }];
  }
}
